import React from 'react';
import './styles.scss';
import ModalWrapper from '../../elements/ModalWrapper';
import { Flex, Stack, Text } from '@mantine/core';

interface ModalDetailLeaderWisdomProps {
  isVisible: boolean;
  photo: string;
  name: string;
  position: string;
  title: string;
  unit: string;
  content: any;
  onClose: () => void;
}

const ModalDetailLeaderWisdom: React.FC<ModalDetailLeaderWisdomProps> = ({
  isVisible,
  photo,
  name,
  position,
  unit,
  content,
  title,
  onClose
}) => {
  return (
    <ModalWrapper
      title={title}
      isVisible={isVisible}
      onClose={onClose}
      size="lg"
    >
      <Flex gap={16} mt={16}>
        <Flex>
          <div className="container-leader-wisdom-section__item__image-cover">
            <img
              className="container-leader-wisdom-section__item__image"
              src={photo}
              alt={name}
            />
          </div>
        </Flex>
        <Flex direction={'column'} gap={10}>
          <Stack gap={0}>
            <Text fz={14} fw={700}>
              {name}
            </Text>
            <Text fz={14} fw={500} c={'gray'}>
              {position}
            </Text>
            <Text fz={14} fw={500} c={'gray'}>
              {unit}
            </Text>
          </Stack>

          <section>
            <Text style={{ whiteSpace: 'pre-line' }}>{content}</Text>
            {/* <div dangerouslySetInnerHTML={{ __html: content }} /> */}
          </section>
        </Flex>
      </Flex>
    </ModalWrapper>
  );
};

export default ModalDetailLeaderWisdom;
